module.exports = __webpack_public_path__ + "img/index_bg.3b8a2acb.jpg";